import type {Catalog, ClassData, MulticlassRequirement} from './catalog';
import type {Character} from './character';
import {MAX_CHARACTER_LEVEL} from './character-state';
import {abilityLabel} from './labels';

const meetsRequirement = (character: Character, {abilities, any, score}: MulticlassRequirement) =>
	any
		? abilities.some((ability) => character.abilityScore(ability) >= score)
		: abilities.every((ability) => character.abilityScore(ability) >= score);

const requirementText = ({abilities, any, score}: MulticlassRequirement) =>
	`${abilities.map(abilityLabel).join(any ? ' или ' : ' и ')} ${score}`;

export function multiclassBlockers(catalog: Catalog, character: Character, candidate: ClassData): string[] {
	if (character.level >= MAX_CHARACTER_LEVEL) return [`персонаж уже ${MAX_CHARACTER_LEVEL}-го уровня`];
	const classes = [candidate, ...character.classes.map(({classData}) => catalog.getClass(classData.id) || classData)];
	return classes.flatMap((classData) => {
		const requirement = classData.multiclassRequirement;
		if (!requirement || meetsRequirement(character, requirement)) return [];
		return [`${classData.title}: ${requirementText(requirement)}`];
	});
}
